import { render, staticRenderFns } from "./RecordsByOdsStatus.vue?vue&type=template&id=0490de92&scoped=true&"
import script from "./RecordsByOdsStatus.vue?vue&type=script&lang=js&"
export * from "./RecordsByOdsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490de92",
  null
  
)

export default component.exports